import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "chef-screen min-h-screen bg-slate-100 text-slate-900" }
const _hoisted_2 = { class: "chef-header" }
const _hoisted_3 = { class: "chef-header-main" }
const _hoisted_4 = { class: "chef-identity" }
const _hoisted_5 = { class: "chef-header-actions" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["aria-expanded"]
const _hoisted_9 = { class: "chef-system-status" }
const _hoisted_10 = {
  id: "chef-settings",
  class: "chef-settings"
}
const _hoisted_11 = ["value"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["value"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 2,
  class: "chef-master-switch"
}
const _hoisted_19 = ["checked", "disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["value", "disabled", "onKeydown"]
const _hoisted_22 = { class: "chef-settings-note" }
const _hoisted_23 = {
  key: 4,
  class: "chef-settings-note"
}
const _hoisted_24 = { class: "chef-main" }
const _hoisted_25 = {
  key: 0,
  class: "chef-notice",
  role: "status"
}
const _hoisted_26 = {
  key: 1,
  class: "chef-notice",
  role: "status"
}
const _hoisted_27 = {
  key: 2,
  class: "chef-notice",
  role: "status"
}
const _hoisted_28 = {
  key: 3,
  class: "chef-notice",
  role: "status"
}
const _hoisted_29 = {
  key: 4,
  class: "chef-notice",
  role: "status"
}
const _hoisted_30 = {
  key: 5,
  class: "chef-notice",
  role: "status"
}
const _hoisted_31 = {
  key: 6,
  class: "chef-notice",
  role: "status"
}
const _hoisted_32 = ["disabled"]
const _hoisted_33 = {
  key: 7,
  class: "chef-notice",
  role: "status"
}
const _hoisted_34 = {
  key: 8,
  class: "chef-notice",
  role: "status"
}
const _hoisted_35 = {
  key: 9,
  class: "chef-notice",
  role: "status"
}
const _hoisted_36 = {
  class: "chef-section",
  "aria-labelledby": "chef-cooking-title"
}
const _hoisted_37 = { class: "chef-section-heading chef-cooking-heading" }
const _hoisted_38 = { id: "chef-cooking-title" }
const _hoisted_39 = { class: "chef-count chef-count-active" }
const _hoisted_40 = ["aria-label"]
const _hoisted_41 = { class: "chef-summary-cooking" }
const _hoisted_42 = { class: "chef-summary-paused" }
const _hoisted_43 = {
  key: 0,
  class: "chef-empty"
}
const _hoisted_44 = {
  key: 1,
  class: "chef-cooking-list"
}
const _hoisted_45 = { class: "chef-task-content" }
const _hoisted_46 = ["aria-label", "onClick"]
const _hoisted_47 = ["src", "alt"]
const _hoisted_48 = { class: "chef-task-info" }
const _hoisted_49 = { class: "chef-task-meta" }
const _hoisted_50 = { class: "chef-table" }
const _hoisted_51 = { class: "chef-table chef-order-number" }
const _hoisted_52 = {
  key: 0,
  class: "chef-appointment-time"
}
const _hoisted_53 = { class: "chef-food-heading" }
const _hoisted_54 = { class: "chef-quantity" }
const _hoisted_55 = {
  key: 0,
  class: "chef-food-cook"
}
const _hoisted_56 = {
  key: 0,
  class: "chef-task-notes"
}
const _hoisted_57 = {
  key: 0,
  class: "chef-task-timing is-overdue"
}
const _hoisted_58 = { class: "chef-card-actions" }
const _hoisted_59 = ["disabled", "onClick"]
const _hoisted_60 = ["disabled", "onClick"]
const _hoisted_61 = ["disabled", "onClick"]
const _hoisted_62 = {
  class: "chef-section",
  "aria-labelledby": "chef-pending-title"
}
const _hoisted_63 = { class: "chef-section-heading" }
const _hoisted_64 = { id: "chef-pending-title" }
const _hoisted_65 = { class: "chef-count" }
const _hoisted_66 = {
  key: 0,
  class: "chef-empty"
}
const _hoisted_67 = {
  key: 1,
  class: "chef-queue"
}
const _hoisted_68 = { class: "chef-queue-order" }
const _hoisted_69 = { class: "chef-order-number" }
const _hoisted_70 = { class: "chef-table" }
const _hoisted_71 = { class: "chef-queue-food" }
const _hoisted_72 = { class: "chef-food-heading" }
const _hoisted_73 = { class: "chef-quantity" }
const _hoisted_74 = {
  key: 0,
  class: "chef-food-cook"
}
const _hoisted_75 = {
  key: 0,
  class: "chef-task-notes"
}
const _hoisted_76 = { class: "chef-queue-tags" }
const _hoisted_77 = {
  key: 0,
  class: "chef-appointment-time"
}
const _hoisted_78 = { class: "chef-pending-actions" }
const _hoisted_79 = ["disabled", "onClick"]
const _hoisted_80 = ["disabled", "onClick"]
const _hoisted_81 = {
  key: 10,
  class: "chef-section",
  "aria-labelledby": "chef-paused-title"
}
const _hoisted_82 = { class: "chef-section-heading" }
const _hoisted_83 = { id: "chef-paused-title" }
const _hoisted_84 = { class: "chef-count chef-count-paused" }
const _hoisted_85 = { class: "chef-paused-list" }
const _hoisted_86 = { class: "chef-task-info" }
const _hoisted_87 = { class: "chef-task-meta" }
const _hoisted_88 = { class: "chef-table" }
const _hoisted_89 = { class: "chef-order-number" }
const _hoisted_90 = {
  key: 0,
  class: "chef-appointment-time"
}
const _hoisted_91 = { class: "chef-food-heading" }
const _hoisted_92 = { class: "chef-quantity" }
const _hoisted_93 = {
  key: 0,
  class: "chef-food-cook"
}
const _hoisted_94 = {
  key: 0,
  class: "chef-task-notes"
}
const _hoisted_95 = { class: "chef-pause-reason" }
const _hoisted_96 = { class: "chef-paused-actions" }
const _hoisted_97 = ["disabled", "onClick"]
const _hoisted_98 = ["disabled", "onClick"]
const _hoisted_99 = {
  key: 11,
  class: "chef-section",
  "aria-labelledby": "chef-scheduled-title"
}
const _hoisted_100 = { class: "chef-section-heading" }
const _hoisted_101 = { id: "chef-scheduled-title" }
const _hoisted_102 = ["aria-expanded"]
const _hoisted_103 = { class: "chef-count" }
const _hoisted_104 = { class: "chef-section-hint" }
const _hoisted_105 = { class: "chef-section-hint" }
const _hoisted_106 = {
  id: "chef-scheduled-queue",
  class: "chef-queue"
}
const _hoisted_107 = { class: "chef-queue-rank" }
const _hoisted_108 = ["title"]
const _hoisted_109 = { class: "chef-order-number" }
const _hoisted_110 = { class: "chef-table" }
const _hoisted_111 = { class: "chef-queue-food" }
const _hoisted_112 = { class: "chef-food-heading" }
const _hoisted_113 = { class: "chef-quantity" }
const _hoisted_114 = {
  key: 0,
  class: "chef-food-cook"
}
const _hoisted_115 = { class: "chef-task-notes" }
const _hoisted_116 = { class: "chef-task-notes" }
const _hoisted_117 = {
  key: 0,
  class: "chef-task-notes"
}
const _hoisted_118 = {
  key: 1,
  class: "chef-task-notes"
}
const _hoisted_119 = { class: "chef-queue-tags" }
const _hoisted_120 = { class: "chef-pending-actions" }
const _hoisted_121 = ["disabled", "onClick"]
const _hoisted_122 = { class: "chef-transfer-dialog" }
const _hoisted_123 = {
  key: 0,
  class: "chef-transfer-food"
}
const _hoisted_124 = { class: "chef-transfer-table" }
const _hoisted_125 = { class: "chef-transfer-food-heading" }
const _hoisted_126 = { class: "chef-transfer-quantity" }
const _hoisted_127 = {
  key: 0,
  class: "chef-transfer-cook"
}
const _hoisted_128 = { class: "chef-transfer-note" }
const _hoisted_129 = { key: 1 }
const _hoisted_130 = ["disabled"]
const _hoisted_131 = ["value"]
const _hoisted_132 = {
  key: 2,
  class: "chef-transfer-note"
}
const _hoisted_133 = { class: "chef-transfer-actions" }

import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
  import { showConfirmDialog, showImagePreview, showToast } from 'vant';
  import { resolveAccessibleShopIds } from '@/constants/auth';
  import type {
    FoodOutDetailsListModel,
    KitchenStoveModel,
    KitchenScheduleSettingsModel,
  } from '@/model/kitchen';
  import { useRestaurantKitchen } from '@/composables/useRestaurantKitchen';
  import { useKitchenMaster } from '@/composables/useKitchenMaster';
  import {
    fetchConfiguredStoves,
    fetchKitchenChefName,
    fetchKitchenQueue,
    changeKitchenStatus,
    changeStoveStatus,
  } from '@/service/kitchen';
  import {
    defaultKitchenScheduleSettings,
    isValidKitchenAdvanceMinutes,
    isKitchenTaskScheduled,
    kitchenAppointmentTime,
    kitchenReleaseTime,
  } from '@/service/kitchenSchedule';
  import {
    fetchKitchenScheduleSettings,
    saveKitchenScheduleSettings,
  } from '@/service/kitchenMaster';
  import { releaseStoveTasks } from '@/service/kitchenDispatch';
  import { assignKitchenTasksAutomatically } from '@/service/kitchenAutoAssignment';
  import { selectKitchenStartBatch, startKitchenTasksTogether } from '@/service/kitchenTaskBatch';
  import { distributeStove } from '@/service/order';
  import { useAuthStore } from '@/store/auth';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ChefScreenView',
  setup(__props) {

  const authStore = useAuthStore();
  const chefName = computed(
    () => authStore.user?.displayName || authStore.user?.username || '厨师',
  );
  const { shops, currentShop, kitchens, currentKitchen, selectionMessage, loadShops } =
    useRestaurantKitchen('chef_screen_kitchen', 'session');
  const stoves = ref<KitchenStoveModel[]>([]);
  const accessibleShops = computed(() => {
    const shopIds = resolveAccessibleShopIds(authStore.user?.roles || []);
    return shopIds
      ? shops.value.filter((shop) => shopIds.includes(Number(shop.shopId)))
      : shops.value;
  });
  const foodDisplayName = (task: FoodOutDetailsListModel): string => {
    const name = task.shopFoodName || task.foodName;
    const spec = task.foodSpecName?.trim();
    return spec && spec !== '标准' ? `${name}（${spec}）` : name;
  };
  const tasks = ref<FoodOutDetailsListModel[]>([]);
  const scheduleSettings = ref<KitchenScheduleSettingsModel>(defaultKitchenScheduleSettings());
  const scheduleSaving = ref(false);
  const scheduleMinutesInput = ref('30');
  const scheduleInputFocused = ref(false);
  const scheduleInputDirty = ref(false);
  const scheduledExpanded = ref(false);
  const scheduleReady = ref(false);
  // 使用每次成功刷新时的时间推进队列，倒计时仍按秒更新。
  const scheduleNow = ref(Date.now());
  const isScheduled = (task: FoodOutDetailsListModel): boolean =>
    isKitchenTaskScheduled(task, scheduleSettings.value, scheduleNow.value);
  const scheduledTasks = computed(() =>
    tasks.value
      .filter(isScheduled)
      .sort(
        (a, b) =>
          (kitchenAppointmentTime(a) || 0) - (kitchenAppointmentTime(b) || 0) ||
          a.orderOutId - b.orderOutId,
      ),
  );
  const canEditSchedule = computed(
    () =>
      kitchenContextReady.value &&
      scheduleReady.value &&
      (stoves.value.length ? isMaster.value : isKitchenChef.value),
  );
  const scheduleDateTime = (timestamp: number | null): string =>
    timestamp === null
      ? '--'
      : new Intl.DateTimeFormat('zh-CN', {
          timeZone: 'Asia/Shanghai',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        }).format(timestamp);
  const scheduleCountdown = (task: FoodOutDetailsListModel): string => {
    const minutes = Math.max(
      0,
      Math.ceil(((kitchenReleaseTime(task, scheduleSettings.value) || 0) - now.value) / 60000),
    );
    return minutes
      ? `${Math.floor(minutes / 60)}小时${minutes % 60}分钟后进入待制作`
      : '即将进入待制作';
  };
  const selectedStoveId = ref('');
  const kitchenChefName = ref('');
  const kitchenContextReady = ref(false);
  // 无灶台时由当前页面控制开班；仅刷新恢复，新打开或切换厨房仍需主动开班。
  const kitchenShiftEnabled = ref(false);
  let restoreShiftPending = performance
    .getEntriesByType('navigation')
    .some((entry) => 'type' in entry && entry.type === 'reload');
  const now = ref(Date.now());
  const {
    isMaster,
    masterSelected,
    masterBusy,
    masterNotice,
    claimMaster,
    stopMaster,
    syncMaster,
    pauseMaster,
  } = useKitchenMaster(
    currentShop,
    currentKitchen,
    now,
    () => ({ account: authStore.user?.username || '', accountName: chefName.value }),
    (hasOtherMasterOnDevice) => {
      // 同设备另一页面接管时，保留新主屏的恢复设置。
      if (!hasOtherMasterOnDevice) writeStored('master', 'false');
      showToast('当前页面已停止自动分配');
    },
  );
  const showSettings = ref(false);
  const loading = ref(false);
  const refreshing = ref(false);
  const manualRefreshing = ref(false);
  const errorMessage = ref('');
  const assignmentMessage = ref('');
  const busyTaskId = ref<number | null>(null);
  const stoveBusy = ref(false);
  const transferTask = ref<FoodOutDetailsListModel | null>(null);
  const transferStoveId = ref('');
  const transferSubmitting = ref(false);
  let restoreMasterPending = false;
  let refreshTimer: ReturnType<typeof setInterval> | undefined;
  let clockTimer: ReturnType<typeof setInterval> | undefined;
  let requestVersion = 0;
  let newDishAudio: HTMLAudioElement | null = null;
  let priorityAudio: HTMLAudioElement | null = null;
  const soundError = ref('');
  let soundScope = '';
  let lastVisibleTaskPriorities: Map<number, number> | null = null;

  const playKitchenSound = async (audio: HTMLAudioElement | null): Promise<void> => {
    try {
      if (!audio) throw new Error('提示音尚未加载');
      audio.currentTime = 0;
      await audio.play();
      soundError.value = '';
    } catch (error) {
      console.warn('播放厨房提示音失败', error);
      soundError.value =
        error instanceof Error && error.name === 'NotAllowedError'
          ? '浏览器暂未允许播放提示音，请点击“启用提示音”。'
          : '提示音暂时无法播放，请点击“启用提示音”重试；仍无声音时请刷新页面。';
    }
  };
  const playNewDishSound = (): Promise<void> => playKitchenSound(newDishAudio);

  const selectedKitchenName = computed(
    () => kitchens.value.find((item) => item.id === currentKitchen.value)?.name || '',
  );
  const selectedStoveName = computed(
    () =>
      stoves.value.find((item) => String(item.stoveId) === selectedStoveId.value)?.stoveName || '',
  );
  const chefLoginNames = computed(() =>
    [authStore.user?.displayName, authStore.user?.username]
      .filter((name): name is string => Boolean(name?.trim()))
      .map((name) => name.trim()),
  );
  const matchesKitchenChef = (configuredNames: string): boolean =>
    configuredNames
      .split(',')
      .map((name) => name.trim())
      .some((name) => Boolean(name) && chefLoginNames.value.includes(name));
  const ownStoves = computed(() =>
    stoves.value.filter((stove) => chefLoginNames.value.includes(stove.stoveName.trim())),
  );
  const isKitchenChef = computed(() => matchesKitchenChef(kitchenChefName.value));
  const selectedStove = computed(() =>
    ownStoves.value.find((stove) => String(stove.stoveId) === selectedStoveId.value),
  );
  const selectedStoveEnabled = computed(() => selectedStove.value?.stoveStatus === 0);
  const canControlShift = computed(
    () =>
      kitchenContextReady.value &&
      (stoves.value.length ? Boolean(selectedStove.value) : isKitchenChef.value),
  );
  const shiftEnabled = computed(() =>
    stoves.value.length ? selectedStoveEnabled.value : kitchenShiftEnabled.value,
  );
  const canOperateCurrentKitchen = computed(() => canControlShift.value && shiftEnabled.value);
  const enabledStoves = computed(() => stoves.value.filter((stove) => stove.stoveStatus === 0));
  const transferTargets = computed(() =>
    enabledStoves.value.filter((stove) => String(stove.stoveId) !== selectedStoveId.value),
  );
  const stoveTaskCount = (stoveId: number): number =>
    tasks.value.filter((task) => Number(task.stoveId) === stoveId && !isScheduled(task)).length;
  const taskActionsDisabled = computed(
    () =>
      loading.value ||
      stoveBusy.value ||
      Boolean(errorMessage.value) ||
      scheduleSaving.value ||
      !scheduleReady.value ||
      busyTaskId.value !== null ||
      !canOperateCurrentKitchen.value,
  );
  const visibleTasks = computed(() =>
    tasks.value.filter(
      (task) =>
        !isScheduled(task) &&
        (!stoves.value.length || String(task.stoveId) === selectedStoveId.value),
    ),
  );
  const cookingTasks = computed(() =>
    visibleTasks.value.filter((task) => task.kitchenStatus === 5 && task.operateStatus !== 1),
  );
  const pendingTasks = computed(() =>
    visibleTasks.value
      .filter((task) => task.kitchenStatus === 0 && task.operateStatus !== 1)
      .sort((a, b) => {
        const priorityDifference = effectivePriority(b) - effectivePriority(a);
        if (priorityDifference) return priorityDifference;
        const timeDifference = timeValue(a.createTime) - timeValue(b.createTime);
        return timeDifference || a.orderOutId - b.orderOutId;
      }),
  );
  const pausedTasks = computed(() =>
    visibleTasks.value.filter((task) => task.operateStatus === 1 || task.kitchenStatus === 9),
  );
  const pendingPortions = computed(() =>
    pendingTasks.value.reduce((sum, task) => sum + (task.quantity || 0), 0),
  );
  const unassignedCount = computed(
    () => tasks.value.filter((task) => !task.stoveId && !isScheduled(task)).length,
  );
  const nextAutoStartTask = computed(() =>
    cookingTasks.value.length
      ? cookingTasks.value.find(
          (task) =>
            selectKitchenStartBatch(task, visibleTasks.value, scheduleSettings.value).length > 1,
        )
      : pendingTasks.value[0],
  );
  const canAutoStart = computed(
    () =>
      Boolean(currentShop.value && currentKitchen.value && currentKitchen.value !== 'all') &&
      accessibleShops.value.some((shop) => String(shop.shopId) === currentShop.value) &&
      !taskActionsDisabled.value &&
      !refreshing.value &&
      Boolean(nextAutoStartTask.value),
  );

  const timeValue = (value?: string): number => {
    if (!value) return 0;
    const parsed = new Date(value.replace(' ', 'T')).getTime();
    return Number.isFinite(parsed) ? parsed : 0;
  };
  const formatClock = (value?: string): string => {
    const parsed = timeValue(value);
    return parsed
      ? new Date(parsed).toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' })
      : '--:--';
  };
  const elapsed = (value?: string): string => {
    if (!timeValue(value)) return '00:00';
    const seconds = Math.max(0, Math.floor((now.value - timeValue(value)) / 1000));
    const minutes = Math.floor(seconds / 60);
    return `${String(minutes).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
  };
  const isOverdue = (task: FoodOutDetailsListModel): boolean =>
    Boolean(
      task.cookTime &&
        timeValue(task.startTime) &&
        now.value - timeValue(task.startTime) > task.cookTime * 60000,
    );
  const shortOrderNo = (value: string): string => value?.slice(-4) || '----';
  const dineLabel = (value?: number): string => {
    if (value === 3) return '外卖';
    if (value === 4) return '打包';
    if (value === 2) return '自提';
    if (value === 5) return '预定';
    return '堂食';
  };
  const appointmentLabel = (task: FoodOutDetailsListModel): string => {
    const day = task.selfPickDate?.trim().match(/^\d{4}-\d{2}-(\d{2})(?:$|[T\s])/)?.[1];
    const date = day ? `${Number(day)}日` : '';
    const time = task.selfPickTime?.trim().replace(/\s*-\s*/g, '–') || '';
    return [date, time].filter(Boolean).join(' ');
  };
  const taskOrderRemark = (task: FoodOutDetailsListModel): string =>
    task.orderRemark?.trim() || task.description?.trim() || '';
  const previewFoodImage = (task: FoodOutDetailsListModel): void => {
    if (!task.imageUrl) return;
    showImagePreview({
      images: [task.imageUrl],
      closeable: true,
      showIndex: false,
      closeOnClickImage: false,
    });
  };
  const effectivePriority = (task: FoodOutDetailsListModel): number =>
    task.operateStatus === 10 ? Math.max(task.priority || 1, 999) : task.priority || 1;
  const priorityLabel = (task: FoodOutDetailsListModel): string => {
    if (effectivePriority(task) >= 999) return '加急';
    if (effectivePriority(task) >= 666) return '叫菜';
    return '普通';
  };
  const priorityClass = (task: FoodOutDetailsListModel): string => {
    if (effectivePriority(task) >= 999) return 'chef-priority-urgent';
    if (effectivePriority(task) >= 666) return 'chef-priority-called';
    return 'bg-slate-100 text-slate-600';
  };

  const storageKey = (kind: string): string =>
    `chef_screen_${kind}_${currentShop.value}_${currentKitchen.value}`;
  const readStored = (kind: string): string => {
    try {
      return localStorage.getItem(storageKey(kind)) || '';
    } catch (error) {
      console.warn('读取厨师大屏设置失败', error);
      return '';
    }
  };
  const writeStored = (kind: string, value: string): void => {
    try {
      localStorage.setItem(storageKey(kind), value);
    } catch (error) {
      console.warn('保存厨师大屏设置失败', error);
    }
  };

  const toggleMaster = async (event: Event): Promise<void> => {
    const input = event.target instanceof HTMLInputElement ? event.target : null;
    if (!input) return;
    if (input.checked) {
      const claimed = await claimMaster();
      if (claimed) {
        writeStored('master', 'true');
        void refreshData();
      }
    } else {
      writeStored('master', 'false');
      await stopMaster();
    }
    input.checked = masterSelected.value;
  };
  const takeoverMaster = async (): Promise<void> => {
    const shop = currentShop.value;
    const kitchen = currentKitchen.value;
    const statusMessage = masterNotice.value || '暂时无法确认当前主屏是否正在运行';
    const confirmed = await showConfirmDialog({
      title: '强制接管主屏',
      message: `${statusMessage}\n\n接管后，将由当前页面负责自动分配，原主屏会停止分配。确认接管？`,
    }).then(
      () => true,
      () => false,
    );
    if (!confirmed || shop !== currentShop.value || kitchen !== currentKitchen.value) return;
    const claimed = await claimMaster(true);
    if (claimed) {
      writeStored('master', 'true');
      showToast('已接管自动分配主屏');
      void refreshData();
    }
  };

  const loadQueue = async (kitchenId: number): Promise<FoodOutDetailsListModel[]> => {
    const response = await fetchKitchenQueue({
      pageNum: 1,
      pageSize: 999,
      data: { kitchenId },
    });
    if (response.code !== 200) throw new Error(response.msg || '加载任务失败');
    return (response.result?.list || [])
      .flatMap((order) =>
        (order.detailsList || []).map((task) => ({
          ...task,
          dineType: order.dineType ?? task.dineType,
          selfPickDate: order.selfPickDate || task.selfPickDate,
          selfPickTime: order.selfPickTime || task.selfPickTime,
          orderRemark: order.description?.trim() || task.description?.trim() || '',
        })),
      )
      .filter(
        (task) =>
          Number(task.shopId) === Number(currentShop.value) &&
          Number(task.kitchenId) === kitchenId &&
          ![8, 9, 999].includes(task.status) &&
          task.kitchenStatus !== 10,
      );
  };

  const refreshData = async (showLoading = false): Promise<void> => {
    if (!currentShop.value || !currentKitchen.value || currentKitchen.value === 'all') return;
    if (!accessibleShops.value.some((shop) => String(shop.shopId) === currentShop.value)) return;
    const version = ++requestVersion;
    const kitchenId = Number(currentKitchen.value);
    refreshing.value = true;
    loading.value = showLoading;
    try {
      const [stoveResponse, queue, settings] = await Promise.all([
        fetchConfiguredStoves(kitchenId),
        loadQueue(kitchenId),
        fetchKitchenScheduleSettings(kitchenId, Number(currentShop.value)),
      ]);
      if (version !== requestVersion) return;
      if (stoveResponse.code !== 200)
        throw new Error(stoveResponse.msg || '暂时无法读取厨师接单情况，请刷新重试');
      const nextStoves = (stoveResponse.result?.list || [])
        .filter((stove) => Number(stove.kitchenId) === kitchenId)
        .sort((a, b) => a.stoveId - b.stoveId);
      const nextChefName = nextStoves.length
        ? ''
        : await fetchKitchenChefName(Number(currentShop.value), kitchenId);
      if (version !== requestVersion) return;
      if (JSON.stringify(stoves.value) !== JSON.stringify(nextStoves)) stoves.value = nextStoves;
      kitchenChefName.value = nextChefName;
      kitchenContextReady.value = true;
      if (stoves.value.length) {
        if (!ownStoves.value.some((stove) => String(stove.stoveId) === selectedStoveId.value)) {
          const stored = readStored('stove');
          selectedStoveId.value = ownStoves.value.some((stove) => String(stove.stoveId) === stored)
            ? stored
            : ownStoves.value.length
            ? String(ownStoves.value[0].stoveId)
            : '';
        }
      } else {
        selectedStoveId.value = '';
      }
      if (stoves.value.length) {
        if (restoreMasterPending) {
          restoreMasterPending = false;
          // 自动恢复申请失败不能覆盖同设备其它页面的主屏设置。
          if (await claimMaster()) writeStored('master', 'true');
        } else {
          await syncMaster();
        }
      }
      if (version !== requestVersion) return;
      let nextQueue = queue;
      let nextAssignmentMessage = '';
      if (isMaster.value && stoves.value.length && queue.some((task) => !task.stoveId)) {
        const result = await assignKitchenTasksAutomatically({
          kitchenId,
          scheduleSettings: settings,
          tasks: queue,
          stoves: stoves.value,
          readQueue: () => loadQueue(kitchenId),
          shouldContinue: () => version === requestVersion && isMaster.value,
          verifyMaster: syncMaster,
        });
        if (version !== requestVersion) return;
        nextAssignmentMessage = result.message;
        if (result.assigned) nextQueue = await loadQueue(kitchenId);
      }
      if (version !== requestVersion) return;
      // 预约配置、时间和队列一起提交，避免刷新中途用新规则展示旧队列。
      if (scheduleSettings.value.advanceMinutes !== settings.advanceMinutes)
        scheduleSettings.value = settings;
      scheduleNow.value = Date.now();
      scheduleReady.value = true;
      // 保留旧队列直到本次读取和分配结束，未变化的数据不触发整组更新。
      if (JSON.stringify(tasks.value) !== JSON.stringify(nextQueue)) tasks.value = nextQueue;
      assignmentMessage.value = nextAssignmentMessage;
      errorMessage.value = '';
    } catch (error) {
      if (version !== requestVersion) return;
      pauseMaster();
      scheduleReady.value = false;
      console.error('加载厨师任务失败', error);
      errorMessage.value = error instanceof Error ? error.message : '加载厨师任务失败';
    } finally {
      if (version === requestVersion) {
        loading.value = false;
        refreshing.value = false;
      }
    }
  };

  const refreshManually = async (): Promise<void> => {
    if (manualRefreshing.value || loading.value || stoveBusy.value || busyTaskId.value !== null)
      return;
    manualRefreshing.value = true;
    try {
      await refreshData();
    } finally {
      manualRefreshing.value = false;
    }
  };

  const invalidateRefresh = (): void => {
    requestVersion++;
    refreshing.value = false;
  };

  const releaseCurrentStoveTasks = async (stoveId: number): Promise<void> => {
    const kitchenId = Number(currentKitchen.value);
    const queue = await loadQueue(kitchenId);
    const result = await releaseStoveTasks(
      queue.filter((task) => Number(task.stoveId) === stoveId),
    );
    if (result.failedCount)
      throw new Error(`${result.failedCount} 道菜未能转交，请点击“重试转交”。`);
    const latestQueue = await loadQueue(kitchenId);
    const remaining = latestQueue.filter((task) => Number(task.stoveId) === stoveId).length;
    if (remaining) throw new Error(`还有 ${remaining} 道菜仍未转交，请点击“重试转交”。`);
  };

  const shiftStorageKey = (): string =>
    `chef_screen_shift_${JSON.stringify([
      authStore.user?.username || '',
      currentShop.value,
      currentKitchen.value,
    ])}`;
  const saveKitchenShift = (): void => {
    try {
      sessionStorage.setItem(shiftStorageKey(), String(kitchenShiftEnabled.value));
    } catch (error) {
      console.warn('保存厨师大屏开班状态失败', error);
    }
  };
  const restoreKitchenShift = (): void => {
    if (!currentShop.value || !currentKitchen.value || currentKitchen.value === 'all') return;
    if (restoreShiftPending) {
      restoreShiftPending = false;
      try {
        kitchenShiftEnabled.value = sessionStorage.getItem(shiftStorageKey()) === 'true';
      } catch (error) {
        console.warn('恢复厨师大屏开班状态失败', error);
      }
    }
    saveKitchenShift();
  };

  const toggleShiftStatus = async (): Promise<void> => {
    if (!canControlShift.value || loading.value || stoveBusy.value || busyTaskId.value !== null)
      return;
    if (!stoves.value.length) {
      invalidateRefresh();
      kitchenShiftEnabled.value = !kitchenShiftEnabled.value;
      saveKitchenShift();
      showToast(kitchenShiftEnabled.value ? '已开始接单' : '已停止接单，不再自动开始制作');
      return;
    }
    const stove = selectedStove.value;
    if (!stove || loading.value || stoveBusy.value || busyTaskId.value !== null) return;
    invalidateRefresh();
    const stoveStatus = stove.stoveStatus === 0 ? 1 : 0;
    stoveBusy.value = true;
    let failureMessage = '';
    try {
      if (stoveStatus === 1) {
        const queue = await loadQueue(Number(currentKitchen.value));
        const cookingCount = queue.filter(
          (task) => Number(task.stoveId) === stove.stoveId && task.kitchenStatus === 5,
        ).length;
        if (cookingCount) {
          const confirmed = await showConfirmDialog({
            title: '确认下班停止',
            message: `当前有 ${cookingCount} 道菜正在制作。停止接单后，未完成的菜品将等待其他厨师接手，并重新开始制作。确认停止接单？`,
            confirmButtonText: '确认停止',
            cancelButtonText: '继续制作',
          }).then(
            () => true,
            () => false,
          );
          if (!confirmed) return;
        }
      }
      const response = await changeStoveStatus({ stoveId: stove.stoveId, stoveStatus });
      if (response.code !== 200)
        throw new Error(response.msg || '未能切换接单状态，请刷新查看后重试');
      if (stoveStatus === 1) await releaseCurrentStoveTasks(stove.stoveId);
      showToast(stoveStatus === 0 ? '已开始接单' : '已停止接单，未完成菜品将等待其他厨师接手');
    } catch (error) {
      console.error('更新厨师启停状态失败', error);
      failureMessage = error instanceof Error ? error.message : '操作失败，请重试';
      showToast(failureMessage);
    } finally {
      await refreshData();
      if (failureMessage) errorMessage.value = failureMessage;
      stoveBusy.value = false;
    }
  };

  const retryHandover = async (): Promise<void> => {
    const stove = selectedStove.value;
    if (
      !stove ||
      selectedStoveEnabled.value ||
      loading.value ||
      stoveBusy.value ||
      busyTaskId.value !== null
    )
      return;
    invalidateRefresh();
    stoveBusy.value = true;
    let failureMessage = '';
    try {
      const response = await fetchConfiguredStoves(Number(currentKitchen.value));
      if (response.code !== 200)
        throw new Error(response.msg || '暂时无法确认厨师是否接单，请刷新重试');
      if (response.result.list.find((item) => item.stoveId === stove.stoveId)?.stoveStatus !== 1)
        throw new Error('厨师的接单情况已变化，请刷新查看');
      await releaseCurrentStoveTasks(stove.stoveId);
      showToast('未完成菜品将等待其他厨师接手');
    } catch (error) {
      console.error('退回厨师菜品失败', error);
      failureMessage = error instanceof Error ? error.message : '退回失败，请重试';
      showToast(failureMessage);
    } finally {
      await refreshData();
      if (failureMessage) errorMessage.value = failureMessage;
      stoveBusy.value = false;
    }
  };

  const editScheduleMinutes = (event: Event): void => {
    if (!(event.target instanceof HTMLInputElement)) return;
    scheduleMinutesInput.value = event.target.value;
    scheduleInputDirty.value =
      scheduleMinutesInput.value !== String(scheduleSettings.value.advanceMinutes);
  };

  const blurScheduleInput = (event: KeyboardEvent): void => {
    if (event.target instanceof HTMLInputElement) event.target.blur();
  };

  const finishScheduleInput = (): void => {
    scheduleInputFocused.value = false;
    void updateSchedule();
  };

  const updateSchedule = async (): Promise<void> => {
    const advanceMinutes =
      scheduleMinutesInput.value.trim() === '' ? NaN : Number(scheduleMinutesInput.value);
    if (!isValidKitchenAdvanceMinutes(advanceMinutes)) {
      showToast('请输入非负整数分钟数');
      return;
    }
    if (advanceMinutes === scheduleSettings.value.advanceMinutes) {
      scheduleInputDirty.value = false;
      return;
    }
    if (
      !canEditSchedule.value ||
      scheduleSaving.value ||
      stoveBusy.value ||
      busyTaskId.value !== null
    )
      return;
    invalidateRefresh();
    const version = requestVersion;
    const kitchenId = Number(currentKitchen.value);
    const shopId = Number(currentShop.value);
    scheduleSaving.value = true;
    try {
      const saved = await saveKitchenScheduleSettings(
        kitchenId,
        shopId,
        { advanceMinutes },
        async () => {
          const response = await fetchConfiguredStoves(kitchenId);
          if (response.code !== 200) throw new Error(response.msg || '读取厨房工位失败');
          if (version !== requestVersion) return false;
          if (response.result.list.some((stove) => Number(stove.kitchenId) === kitchenId))
            return syncMaster();
          const name = await fetchKitchenChefName(shopId, kitchenId);
          return version === requestVersion && matchesKitchenChef(name);
        },
      );
      if (version !== requestVersion) return;
      scheduleSettings.value = saved;
      scheduleMinutesInput.value = String(saved.advanceMinutes);
      scheduleInputDirty.value = false;
      await refreshData();
      if (errorMessage.value) throw new Error('设置已提交，请刷新核对结果');
      showToast(`预约菜品提前${saved.advanceMinutes}分钟进入待制作`);
    } catch (error) {
      console.error('保存预约制作设置失败', error);
      if (Number(currentKitchen.value) === kitchenId && Number(currentShop.value) === shopId) {
        errorMessage.value = error instanceof Error ? error.message : '保存预约制作设置失败';
        showToast(errorMessage.value);
      }
    } finally {
      scheduleSaving.value = false;
    }
  };

  const claimScheduledTask = async (task: FoodOutDetailsListModel): Promise<void> => {
    if (taskActionsDisabled.value) return;
    // 与普通待制作操作一致，点击时使后台刷新失效，再读取最新状态。
    invalidateRefresh();
    const version = requestVersion;
    const kitchenId = Number(currentKitchen.value);
    const shopId = Number(currentShop.value);
    const stoveId = selectedStoveId.value;
    const contextValid = (): boolean =>
      version === requestVersion && stoveId === selectedStoveId.value;
    busyTaskId.value = task.orderOutId;
    let submitted = false;
    let failureMessage = '';
    try {
      const [response, queue] = await Promise.all([
        fetchConfiguredStoves(kitchenId),
        loadQueue(kitchenId),
      ]);
      if (!contextValid()) return;
      if (response.code !== 200) throw new Error(response.msg || '读取厨师接单状态失败');
      const configured = response.result.list.filter(
        (stove) => Number(stove.kitchenId) === kitchenId,
      );
      const latest = queue.find((item) => item.orderOutId === task.orderOutId);
      if (
        !latest ||
        latest.kitchenStatus !== 0 ||
        latest.operateStatus === 1 ||
        (latest.stoveId && String(latest.stoveId) !== stoveId)
      )
        throw new Error('菜品已被认领或制作状态已变化，请刷新查看');
      if (configured.length) {
        const target = configured.find(
          (stove) =>
            String(stove.stoveId) === stoveId &&
            chefLoginNames.value.includes(stove.stoveName.trim()) &&
            stove.stoveStatus === 0,
        );
        if (!target) throw new Error('当前未接单，请上班启用后重试');
        if (!latest.stoveId) {
          submitted = true;
          const assigned = await distributeStove({
            orderOutId: task.orderOutId,
            stoveId: target.stoveId,
          });
          if (assigned.code !== 200) throw new Error(assigned.msg || '认领失败');
          if (!contextValid()) return;
          const reset = await changeKitchenStatus({
            orderOutId: task.orderOutId,
            kitchenStatus: 0,
          });
          if (reset.code !== 200) throw new Error(reset.msg || '已认领，暂未确认待制作状态');
        }
      } else {
        const name = await fetchKitchenChefName(shopId, kitchenId);
        if (!kitchenShiftEnabled.value || !matchesKitchenChef(name))
          throw new Error('当前无法开始制作，请确认负责人已开班');
      }
      if (!contextValid()) return;
      // 认领后再核对归属；提前开工只提交选中的一道菜。
      const currentQueue = await loadQueue(kitchenId);
      if (!contextValid()) return;
      const current = currentQueue.find((item) => item.orderOutId === task.orderOutId);
      if (
        !current ||
        current.kitchenStatus !== 0 ||
        current.operateStatus === 1 ||
        (configured.length ? String(current.stoveId) !== stoveId : Boolean(current.stoveId))
      )
        throw new Error('菜品归属或制作状态已变化，请刷新查看');
      submitted = true;
      const started = await changeKitchenStatus({ orderOutId: task.orderOutId, kitchenStatus: 5 });
      if (started.code !== 200) throw new Error(started.msg || '开始制作失败');
      if (!contextValid()) return;
      const verified = await loadQueue(kitchenId);
      if (!contextValid()) return;
      const result = verified.find((item) => item.orderOutId === task.orderOutId);
      if (result?.kitchenStatus !== 5 || (configured.length && String(result.stoveId) !== stoveId))
        throw new Error('暂未确认开工结果');
      showToast('已开始制作');
    } catch (error) {
      console.error('提前开始预约菜品失败', error);
      failureMessage = error instanceof Error ? error.message : '操作失败，请重试';
      if (submitted) failureMessage = `操作已提交，请核对负责厨师和制作状态：${failureMessage}`;
      showToast(failureMessage);
    } finally {
      if (contextValid()) {
        await refreshData();
        if (submitted && failureMessage) errorMessage.value = failureMessage;
      }
      busyTaskId.value = null;
    }
  };

  const changeTaskStatus = async (
    task: FoodOutDetailsListModel,
    kitchenStatus: 5 | 9 | 10,
  ): Promise<void> => {
    if (taskActionsDisabled.value || (task.operateStatus === 1 && kitchenStatus === 5)) return;
    const currentTask = tasks.value.find((item) => item.orderOutId === task.orderOutId);
    if (!currentTask || currentTask.kitchenStatus === kitchenStatus) return;
    invalidateRefresh();
    const version = requestVersion;
    const stoveId = selectedStoveId.value;
    busyTaskId.value = task.orderOutId;
    let statusSubmitted = false;
    try {
      const kitchenId = Number(currentKitchen.value);
      const stoveResponse = await fetchConfiguredStoves(kitchenId);
      if (stoveResponse.code !== 200)
        throw new Error(stoveResponse.msg || '暂时无法确认厨师是否接单，请刷新重试');
      const configuredStoves = (stoveResponse.result?.list || []).filter(
        (stove) => Number(stove.kitchenId) === kitchenId,
      );
      if (configuredStoves.length) {
        if (
          !configuredStoves.some(
            (stove) => stove.stoveId === selectedStove.value?.stoveId && stove.stoveStatus === 0,
          )
        )
          throw new Error('当前已停止接单，请刷新后点击“上班启用”');
      } else {
        const kitchenContactName = await fetchKitchenChefName(Number(currentShop.value), kitchenId);
        if (!kitchenShiftEnabled.value) throw new Error('当前未开班，请点击“上班启用”');
        if (!matchesKitchenChef(kitchenContactName))
          throw new Error('当前暂不能操作这些菜品，请刷新查看；如仍无法操作，请联系负责人');
      }
      let changedTaskIds = [task.orderOutId];
      let failedCount = 0;
      let batchErrorMessage = '';
      if (kitchenStatus === 5) {
        const [queue, settings] = await Promise.all([
          loadQueue(kitchenId),
          fetchKitchenScheduleSettings(kitchenId, Number(currentShop.value)),
        ]);
        if (version !== requestVersion || stoveId !== selectedStoveId.value) return;
        const latestTask = queue.find((item) => item.orderOutId === task.orderOutId);
        if (
          !latestTask ||
          (configuredStoves.length && Number(latestTask.stoveId || 0) !== Number(stoveId || 0)) ||
          latestTask.operateStatus === 1 ||
          ![0, 9].includes(latestTask.kitchenStatus)
        )
          throw new Error('菜品的制作进度或负责厨师已变化，请刷新查看');
        const result = await startKitchenTasksTogether(
          selectKitchenStartBatch(latestTask, queue, settings),
          () => version === requestVersion && stoveId === selectedStoveId.value,
        );
        changedTaskIds = result.startedTaskIds;
        failedCount = result.failedCount;
        batchErrorMessage = result.message;
        statusSubmitted = changedTaskIds.length > 0;
      } else {
        if (version !== requestVersion || stoveId !== selectedStoveId.value) return;
        const response = await changeKitchenStatus({ orderOutId: task.orderOutId, kitchenStatus });
        if (response.code !== 200) throw new Error(response.msg || '操作失败');
        statusSubmitted = true;
      }
      if (version !== requestVersion || stoveId !== selectedStoveId.value) return;
      await refreshData();
      if (errorMessage.value)
        throw new Error('操作已提交，暂时无法查看结果。请刷新确认，避免重复操作');
      if (
        changedTaskIds.some((id) => {
          const updatedTask = tasks.value.find((item) => item.orderOutId === id);
          return kitchenStatus === 10
            ? Boolean(updatedTask)
            : updatedTask?.kitchenStatus !== kitchenStatus;
        })
      ) {
        throw new Error('操作已提交，暂未确认操作结果。请刷新查看，避免重复操作');
      }
      if (failedCount)
        throw new Error(`有${failedCount}道菜未能开始制作：${batchErrorMessage}。请刷新核对后重试`);
      showToast(
        kitchenStatus === 10
          ? '制作完成'
          : kitchenStatus === 9
          ? '已暂停制作'
          : changedTaskIds.length > 1
          ? `已一起开始制作${changedTaskIds.length}道菜`
          : '已开始制作',
      );
    } catch (error) {
      console.error('更新厨房制作状态失败', error);
      const message = error instanceof Error ? error.message : '操作失败，请重试';
      if (statusSubmitted) errorMessage.value = message;
      showToast(message);
    } finally {
      busyTaskId.value = null;
    }
  };

  const closeTransfer = (): void => {
    if (transferSubmitting.value) return;
    transferTask.value = null;
    transferStoveId.value = '';
    busyTaskId.value = null;
  };

  const openTransfer = async (task: FoodOutDetailsListModel): Promise<void> => {
    if (taskActionsDisabled.value || !selectedStove.value) return;
    invalidateRefresh();
    const version = requestVersion;
    const kitchenId = Number(currentKitchen.value);
    busyTaskId.value = task.orderOutId;
    try {
      const [response, queue] = await Promise.all([
        fetchConfiguredStoves(kitchenId),
        loadQueue(kitchenId),
      ]);
      if (version !== requestVersion) return;
      if (response.code !== 200)
        throw new Error(response.msg || '暂时无法确认厨师是否接单，请刷新重试');
      stoves.value = response.result.list.filter((stove) => Number(stove.kitchenId) === kitchenId);
      tasks.value = queue;
      const currentTask = visibleTasks.value.find((item) => item.orderOutId === task.orderOutId);
      if (!currentTask || !selectedStoveEnabled.value)
        throw new Error('菜品的制作进度或厨师的接单情况已变化，请刷新查看');
      transferStoveId.value = '';
      transferTask.value = currentTask;
    } catch (error) {
      console.error('读取转交信息失败', error);
      showToast(error instanceof Error ? error.message : '读取转交信息失败');
    } finally {
      if (!transferTask.value) busyTaskId.value = null;
    }
  };

  const confirmTransfer = async (): Promise<void> => {
    const task = transferTask.value;
    const targetId = Number(transferStoveId.value);
    if (!task || !targetId || transferSubmitting.value) return;
    const version = requestVersion;
    const sourceStoveId = selectedStoveId.value;
    transferSubmitting.value = true;
    let failureMessage = '';
    let mutationStarted = false;
    try {
      const kitchenId = Number(currentKitchen.value);
      const [response, queue] = await Promise.all([
        fetchConfiguredStoves(kitchenId),
        loadQueue(kitchenId),
      ]);
      if (version !== requestVersion || sourceStoveId !== selectedStoveId.value)
        throw new Error('当前厨房或厨师已变化，请重新选择菜品');
      if (response.code !== 200)
        throw new Error(response.msg || '暂时无法确认厨师是否接单，请刷新重试');
      stoves.value = response.result.list.filter((stove) => Number(stove.kitchenId) === kitchenId);
      tasks.value = queue;
      const currentTask = queue.find((item) => item.orderOutId === task.orderOutId);
      const target = transferTargets.value.find((stove) => stove.stoveId === targetId);
      if (!currentTask || String(currentTask.stoveId) !== selectedStoveId.value)
        throw new Error('菜品已完成、取消或转交，请刷新确认');
      if (!selectedStoveEnabled.value) throw new Error('当前已停止接单，请刷新查看');
      if (!target) throw new Error('这位厨师已停止接单，请选择其他厨师');
      // 先暂停制作，再直接指定接收厨师，避免退回未分配队列被主屏抢先分配。
      if (currentTask.kitchenStatus === 5) {
        const paused = await changeKitchenStatus({ orderOutId: task.orderOutId, kitchenStatus: 9 });
        if (paused.code !== 200) throw new Error(paused.msg || '暂停制作失败');
        mutationStarted = true;
      }
      const assigned = await distributeStove({ orderOutId: task.orderOutId, stoveId: targetId });
      if (assigned.code !== 200) throw new Error(assigned.msg || '转交失败');
      mutationStarted = true;
      const reset = await changeKitchenStatus({ orderOutId: task.orderOutId, kitchenStatus: 0 });
      if (reset.code !== 200)
        throw new Error(
          reset.msg || '已转交，暂未确认菜品是否可以开始制作。请刷新查看，避免重复转交',
        );
      const latest = await loadQueue(kitchenId);
      tasks.value = latest;
      const transferred = latest.find((item) => item.orderOutId === task.orderOutId);
      if (Number(transferred?.stoveId) !== targetId || transferred?.kitchenStatus !== 0)
        throw new Error('转交已提交，暂未确认转交结果。请刷新查看，避免重复转交');
      showToast(`已转交给${target.stoveName}`);
      transferTask.value = null;
      transferStoveId.value = '';
    } catch (error) {
      console.error('转交菜品失败', error);
      failureMessage = error instanceof Error ? error.message : '转交失败，请重试';
      if (mutationStarted)
        failureMessage = `暂未确认转交结果：${failureMessage}。请刷新查看由谁制作以及制作进度。`;
      showToast(failureMessage);
      if (mutationStarted) {
        transferTask.value = null;
        transferStoveId.value = '';
      }
    } finally {
      if (!transferTask.value) {
        await refreshData();
        if (failureMessage) errorMessage.value = failureMessage;
        busyTaskId.value = null;
      }
      transferSubmitting.value = false;
    }
  };

  const autoStartNext = async (): Promise<void> => {
    if (!canAutoStart.value) return;
    const version = requestVersion;
    const kitchenId = Number(currentKitchen.value);
    const stoveId = selectedStoveId.value;
    busyTaskId.value = nextAutoStartTask.value?.orderOutId || null;
    try {
      // 开工前重新读取，避免按旧队列开始已暂停、已转交或顺序已变化的菜品。
      const [stoveResponse, queue, settings] = await Promise.all([
        fetchConfiguredStoves(kitchenId),
        loadQueue(kitchenId),
        fetchKitchenScheduleSettings(kitchenId, Number(currentShop.value)),
      ]);
      if (version !== requestVersion || stoveId !== selectedStoveId.value) return;
      if (stoveResponse.code !== 200)
        throw new Error(stoveResponse.msg || '暂时无法确认厨师是否接单，请刷新重试');
      stoves.value = stoveResponse.result.list.filter(
        (stove) => Number(stove.kitchenId) === kitchenId,
      );
      scheduleSettings.value = settings;
      scheduleNow.value = Date.now();
      tasks.value = queue;
      if (stoves.value.length) {
        if (!selectedStoveEnabled.value) return;
      } else {
        const kitchenContactName = await fetchKitchenChefName(Number(currentShop.value), kitchenId);
        if (version !== requestVersion || stoveId !== selectedStoveId.value) return;
        kitchenChefName.value = kitchenContactName;
        if (!canOperateCurrentKitchen.value) return;
      }
      const task = nextAutoStartTask.value;
      if (!task) return;
      busyTaskId.value = task.orderOutId;
      const result = await startKitchenTasksTogether(
        selectKitchenStartBatch(task, queue, scheduleSettings.value),
        () => version === requestVersion && stoveId === selectedStoveId.value,
      );
      if (version !== requestVersion || stoveId !== selectedStoveId.value) return;
      await refreshData();
      if (errorMessage.value)
        throw new Error('已尝试自动开始制作，暂时无法查看结果。请刷新确认，避免重复操作');
      if (
        result.startedTaskIds.some(
          (id) => tasks.value.find((item) => item.orderOutId === id)?.kitchenStatus !== 5,
        )
      )
        throw new Error('已尝试自动开始制作，暂未确认操作结果。请刷新查看，避免重复操作');
      if (result.failedCount)
        throw new Error(
          `有${result.failedCount}道菜未能自动开始制作：${result.message}。请刷新核对后重试`,
        );
      showToast(
        result.startedTaskIds.length > 1
          ? `已一起自动开始：${task.foodName}（${result.startedTaskIds.length}道菜）`
          : `已自动开始：${task.foodName}`,
      );
    } catch (error) {
      console.error('自动开始制作失败', error);
      if (version === requestVersion || Number(currentKitchen.value) === kitchenId) {
        errorMessage.value = error instanceof Error ? error.message : '自动开始失败，请刷新重试';
        showToast(errorMessage.value);
      }
    } finally {
      busyTaskId.value = null;
    }
  };

  watch(
    [
      visibleTasks,
      currentShop,
      currentKitchen,
      selectedStoveId,
      refreshing,
      loading,
      kitchenContextReady,
    ],
    () => {
      if (!kitchenContextReady.value || refreshing.value || loading.value) return;
      const scope = JSON.stringify([
        currentShop.value,
        currentKitchen.value,
        stoves.value.length ? selectedStoveId.value : 'kitchen',
      ]);
      const nextPriorities = new Map(
        visibleTasks.value.map((task) => {
          const priority = effectivePriority(task);
          const alertLevel = priority >= 999 ? 2 : priority >= 666 ? 1 : 0;
          return [task.orderOutId, alertLevel];
        }),
      );
      const previousPriorities = lastVisibleTaskPriorities;
      const canNotify = soundScope === scope && previousPriorities !== null;
      const hasNewDish =
        canNotify && [...nextPriorities.keys()].some((id) => !previousPriorities.has(id));
      const hasPriorityAlert =
        canNotify &&
        [...nextPriorities].some(([id, level]) => {
          const previousLevel = previousPriorities.get(id);
          return previousLevel !== undefined && level > previousLevel;
        });
      soundScope = scope;
      lastVisibleTaskPriorities = nextPriorities;
      // 新菜品使用原提示音；已有菜品叫菜、加急升级使用独立提示音，各类同轮合并。
      if (hasNewDish) void playNewDishSound();
      if (hasPriorityAlert) void playKitchenSound(priorityAudio);
    },
    { flush: 'post' },
  );

  watch(canAutoStart, (ready) => {
    if (ready) void autoStartNext();
  });

  watch(kitchens, (items) => {
    if (items.length && !items.some((item) => item.id === currentKitchen.value)) {
      currentKitchen.value = items[0].id;
    }
  });
  watch(accessibleShops, (items) => {
    if (items.length && !items.some((shop) => String(shop.shopId) === currentShop.value)) {
      currentShop.value = String(items[0].shopId);
    }
  });
  watch(
    () => scheduleSettings.value.advanceMinutes,
    (minutes) => {
      // 后台同步只更新未编辑的输入，不覆盖正在输入或保存失败后待重试的数字。
      if (!scheduleInputFocused.value && !scheduleInputDirty.value && !scheduleSaving.value)
        scheduleMinutesInput.value = String(minutes);
    },
  );

  watch(
    () => scheduledTasks.value.length,
    (count) => {
      if (!count) scheduledExpanded.value = false;
    },
  );
  watch([currentShop, currentKitchen], () => {
    soundScope = '';
    scheduledExpanded.value = false;
    scheduleMinutesInput.value = '30';
    scheduleInputFocused.value = false;
    scheduleInputDirty.value = false;
    lastVisibleTaskPriorities = null;
    invalidateRefresh();
    loading.value = false;
    tasks.value = [];
    scheduleReady.value = false;
    scheduleSettings.value = defaultKitchenScheduleSettings();
    stoves.value = [];
    kitchenChefName.value = '';
    kitchenContextReady.value = false;
    kitchenShiftEnabled.value = false;
    restoreKitchenShift();
    selectedStoveId.value = '';
    restoreMasterPending = readStored('master') === 'true';
    void refreshData(true);
  });
  watch(selectedStoveId, (value) => {
    if (value) writeStored('stove', value);
  });

  onMounted(() => {
    try {
      const src = new URL('@/assets/audio/new_order.mp3', import.meta.url).href;
      newDishAudio = new Audio(src);
      newDishAudio.preload = 'auto';
      newDishAudio.volume = 1.0;
      const prioritySrc = new URL('@/assets/audio/kitchen_alert.wav', import.meta.url).href;
      priorityAudio = new Audio(prioritySrc);
      priorityAudio.preload = 'auto';
      priorityAudio.volume = 1.0;
    } catch (error) {
      console.warn('厨房提示音初始化失败', error);
      soundError.value = '提示音加载失败，请刷新页面重试。';
    }
    void loadShops();
    refreshTimer = setInterval(() => {
      if (
        !refreshing.value &&
        !scheduleSaving.value &&
        !stoveBusy.value &&
        busyTaskId.value === null
      )
        void refreshData();
    }, 15000);
    clockTimer = setInterval(() => (now.value = Date.now()), 1000);
  });
  onUnmounted(() => {
    requestVersion++;
    newDishAudio?.pause();
    newDishAudio = null;
    priorityAudio?.pause();
    priorityAudio = null;
    if (refreshTimer) clearInterval(refreshTimer);
    if (clockTimer) clearInterval(clockTimer);
  });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", null, _toDisplayString(selectedKitchenName.value || '厨师任务大屏'), 1),
          _cache[7] || (_cache[7] = _createElementVNode("span", {
            class: "chef-identity-divider",
            "aria-hidden": "true"
          }, null, -1)),
          _createElementVNode("strong", null, _toDisplayString(selectedStoveName.value || chefName.value), 1),
          _createElementVNode("span", {
            class: _normalizeClass(["chef-shift-status", { 'is-enabled': canOperateCurrentKitchen.value }])
          }, _toDisplayString(canControlShift.value ? (shiftEnabled.value ? '接单中' : '已停止接单') : '仅查看'), 3)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (canControlShift.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "chef-header-button chef-shift-button",
                disabled: loading.value || scheduleSaving.value || stoveBusy.value || busyTaskId.value !== null || _unref(masterBusy),
                onClick: toggleShiftStatus
              }, _toDisplayString(stoveBusy.value ? '处理中…' : shiftEnabled.value ? '下班停止' : '上班启用'), 9, _hoisted_6))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "chef-header-button",
            disabled: 
              loading.value || scheduleSaving.value || manualRefreshing.value || stoveBusy.value || busyTaskId.value !== null
            ,
            onClick: refreshManually
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["fas fa-sync-alt", { 'fa-spin': loading.value || manualRefreshing.value }]),
              "aria-hidden": "true"
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(loading.value || manualRefreshing.value ? '刷新中' : '刷新'), 1)
          ], 8, _hoisted_7),
          _createElementVNode("button", {
            type: "button",
            class: "chef-header-button",
            "aria-expanded": showSettings.value || !_unref(currentKitchen),
            "aria-controls": "chef-settings",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showSettings.value = !showSettings.value))
          }, _cache[8] || (_cache[8] = [
            _createElementVNode("i", {
              class: "fas fa-sliders-h",
              "aria-hidden": "true"
            }, null, -1),
            _createTextVNode("设置 ", -1)
          ]), 8, _hoisted_8),
          _createVNode(_component_router_link, {
            to: "/",
            class: "chef-home-link",
            "aria-label": "返回首页"
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createElementVNode("i", {
                class: "fas fa-home",
                "aria-hidden": "true"
              }, null, -1)
            ])),
            _: 1,
            __: [9]
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", null, [
          _cache[10] || (_cache[10] = _createElementVNode("i", {
            class: "fas fa-play-circle",
            "aria-hidden": "true"
          }, null, -1)),
          _createTextVNode(_toDisplayString(canOperateCurrentKitchen.value ? '空闲时自动开始下一道菜' : '制作任务（仅查看）'), 1)
        ]),
        (stoves.value.length)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["chef-master-status", { 'is-master': _unref(isMaster) }])
            }, _toDisplayString(_unref(isMaster) ? '自动分配主屏' : '跟随主屏分配'), 3))
          : _createCommentVNode("", true),
        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "chef-refresh-note" }, "每 15 秒刷新", -1))
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_10, [
        _createElementVNode("label", null, [
          _cache[12] || (_cache[12] = _createElementVNode("span", null, "餐厅", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(currentShop) ? (currentShop).value = $event : null)),
            disabled: ""
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accessibleShops.value, (shop) => {
              return (_openBlock(), _createElementBlock("option", {
                key: shop.shopId,
                value: String(shop.shopId)
              }, _toDisplayString(shop.shopName), 9, _hoisted_11))
            }), 128))
          ], 512), [
            [_vModelSelect, _unref(currentShop)]
          ])
        ]),
        (_unref(kitchens).length)
          ? (_openBlock(), _createElementBlock("label", _hoisted_12, [
              _cache[13] || (_cache[13] = _createElementVNode("span", null, "厨房", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(currentKitchen) ? (currentKitchen).value = $event : null)),
                disabled: loading.value || scheduleSaving.value || stoveBusy.value || busyTaskId.value !== null || _unref(masterBusy)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(kitchens), (kitchen) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: kitchen.id,
                    value: kitchen.id
                  }, _toDisplayString(kitchen.name), 9, _hoisted_14))
                }), 128))
              ], 8, _hoisted_13), [
                [_vModelSelect, _unref(currentKitchen)]
              ])
            ]))
          : _createCommentVNode("", true),
        (ownStoves.value.length)
          ? (_openBlock(), _createElementBlock("label", _hoisted_15, [
              _cache[14] || (_cache[14] = _createElementVNode("span", null, "厨师工位", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedStoveId).value = $event)),
                disabled: loading.value || scheduleSaving.value || stoveBusy.value || busyTaskId.value !== null || _unref(masterBusy)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ownStoves.value, (stove) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: stove.stoveId,
                    value: String(stove.stoveId)
                  }, _toDisplayString(stove.stoveName) + "（" + _toDisplayString(stove.stoveStatus === 0 ? '已启用' : '已停止') + "） ", 9, _hoisted_17))
                }), 128))
              ], 8, _hoisted_16), [
                [_vModelSelect, selectedStoveId.value]
              ])
            ]))
          : _createCommentVNode("", true),
        (stoves.value.length)
          ? (_openBlock(), _createElementBlock("label", _hoisted_18, [
              _createElementVNode("input", {
                checked: _unref(masterSelected),
                disabled: scheduleSaving.value || stoveBusy.value || busyTaskId.value !== null || loading.value || _unref(masterBusy),
                type: "checkbox",
                onChange: toggleMaster
              }, null, 40, _hoisted_19),
              _cache[15] || (_cache[15] = _createElementVNode("span", null, "本页面为自动分配主屏", -1))
            ]))
          : _createCommentVNode("", true),
        (stoves.value.length && !_unref(isMaster))
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              class: "chef-header-button",
              disabled: scheduleSaving.value || stoveBusy.value || busyTaskId.value !== null || loading.value || _unref(masterBusy),
              onClick: takeoverMaster
            }, " 强制接管主屏 ", 8, _hoisted_20))
          : _createCommentVNode("", true),
        _createElementVNode("label", null, [
          _cache[16] || (_cache[16] = _createElementVNode("span", null, "预约提前制作", -1)),
          _createElementVNode("input", {
            type: "number",
            min: "0",
            step: "1",
            inputmode: "numeric",
            "aria-label": "预约提前制作分钟数",
            value: scheduleMinutesInput.value,
            disabled: !canEditSchedule.value || scheduleSaving.value || stoveBusy.value || busyTaskId.value !== null,
            onInput: editScheduleMinutes,
            onFocus: _cache[4] || (_cache[4] = ($event: any) => (scheduleInputFocused.value = true)),
            onBlur: finishScheduleInput,
            onKeydown: _withKeys(_withModifiers(blurScheduleInput, ["prevent"]), ["enter"])
          }, null, 40, _hoisted_21),
          _cache[17] || (_cache[17] = _createElementVNode("span", null, "分钟", -1))
        ]),
        _createElementVNode("p", _hoisted_22, "以预约开始时间为准；" + _toDisplayString(stoves.value.length ? '由主屏修改，各屏共享' : '由厨房负责人修改'), 1),
        _createElementVNode("button", {
          type: "button",
          class: "chef-header-button",
          onClick: playNewDishSound
        }, _cache[18] || (_cache[18] = [
          _createElementVNode("i", {
            class: "fas fa-volume-up",
            "aria-hidden": "true"
          }, null, -1),
          _createTextVNode("测试提示音 ", -1)
        ])),
        (stoves.value.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_23, "同一厨房开启一个主屏即可自动分配菜品；超过 60 秒未收到更新，会提醒主屏已断开连接。"))
          : _createCommentVNode("", true)
      ], 512), [
        [_vShow, showSettings.value || !_unref(currentKitchen)]
      ])
    ]),
    _createElementVNode("main", _hoisted_24, [
      (soundError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("span", null, _toDisplayString(soundError.value), 1),
            _createElementVNode("button", {
              type: "button",
              class: "chef-button chef-button-secondary",
              onClick: playNewDishSound
            }, " 启用提示音 ")
          ]))
        : _createCommentVNode("", true),
      (stoves.value.length && _unref(masterNotice))
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_unref(masterNotice)), 1))
        : _createCommentVNode("", true),
      (_unref(selectionMessage) || errorMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(errorMessage.value || _unref(selectionMessage)), 1))
        : _createCommentVNode("", true),
      (kitchenContextReady.value && !stoves.value.length && !isKitchenChef.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, " 当前可查看整个厨房的制作任务，暂不能操作。 "))
        : _createCommentVNode("", true),
      (stoves.value.length && !selectedStove.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, " 暂未安排你的制作工位，当前无法查看个人制作任务。请联系负责人确认。 "))
        : (canControlShift.value && !stoves.value.length && !shiftEnabled.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, " 当前未开班，可查看制作任务；点击“上班启用”后自动开始制作。 "))
          : (selectedStove.value && !selectedStoveEnabled.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("span", null, [
                  _cache[19] || (_cache[19] = _createTextVNode("当前已停止接单，点击“上班启用”后参与分配。 ", -1)),
                  (visibleTasks.value.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("还有 " + _toDisplayString(visibleTasks.value.length) + " 道菜等待转交。", 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                (visibleTasks.value.length)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "chef-button chef-button-secondary",
                      disabled: loading.value || scheduleSaving.value || stoveBusy.value || busyTaskId.value !== null || _unref(masterBusy),
                      onClick: retryHandover
                    }, _toDisplayString(stoveBusy.value ? '转交中…' : '重试转交'), 9, _hoisted_32))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
      (stoves.value.length && !enabledStoves.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, " 当前暂无接单中的厨师，菜品将继续等待分配。 "))
        : _createCommentVNode("", true),
      (stoves.value.length && unassignedCount.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _createElementVNode("span", null, [
              _createTextVNode("待分配 " + _toDisplayString(unassignedCount.value) + " 道菜。 ", 1),
              (!_unref(isMaster))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("请保持自动分配主屏开启。")
                  ], 64))
                : (assignmentMessage.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(assignmentMessage.value), 1)
                    ], 64))
                  : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (assignmentMessage.value && !unassignedCount.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(assignmentMessage.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("h2", _hoisted_38, [
            _cache[20] || (_cache[20] = _createElementVNode("i", {
              class: "fas fa-utensils",
              "aria-hidden": "true"
            }, null, -1)),
            _cache[21] || (_cache[21] = _createTextVNode("正在制作 ", -1)),
            _createElementVNode("span", _hoisted_39, _toDisplayString(cookingTasks.value.length), 1)
          ]),
          _createElementVNode("div", {
            class: "chef-task-summary",
            "aria-label": stoves.value.length ? '当前厨师菜品任务汇总' : '当前厨房菜品任务汇总'
          }, [
            _createElementVNode("span", null, [
              _cache[22] || (_cache[22] = _createTextVNode("合计 ", -1)),
              _createElementVNode("strong", null, _toDisplayString(cookingTasks.value.length + pendingTasks.value.length + pausedTasks.value.length), 1),
              _cache[23] || (_cache[23] = _createTextVNode(" 道", -1))
            ]),
            _createElementVNode("span", _hoisted_41, [
              _cache[24] || (_cache[24] = _createTextVNode("制作中 ", -1)),
              _createElementVNode("strong", null, _toDisplayString(cookingTasks.value.length), 1)
            ]),
            _createElementVNode("span", null, [
              _cache[27] || (_cache[27] = _createTextVNode("待制作 ", -1)),
              _createElementVNode("strong", null, _toDisplayString(pendingTasks.value.length), 1),
              (!stoves.value.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[25] || (_cache[25] = _createTextVNode(" 道 / ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(pendingPortions.value), 1),
                    _cache[26] || (_cache[26] = _createTextVNode("份 ", -1))
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", _hoisted_42, [
              _cache[28] || (_cache[28] = _createTextVNode("已暂停 ", -1)),
              _createElementVNode("strong", null, _toDisplayString(pausedTasks.value.length), 1)
            ])
          ], 8, _hoisted_40),
          _cache[29] || (_cache[29] = _createElementVNode("span", { class: "chef-section-hint" }, "完成后进入厨房出餐流程", -1))
        ]),
        (!cookingTasks.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_43, _cache[30] || (_cache[30] = [
              _createElementVNode("i", {
                class: "fas fa-utensils",
                "aria-hidden": "true"
              }, null, -1),
              _createTextVNode("当前没有正在制作的菜品 ", -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_44, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cookingTasks.value, (task) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: task.orderOutId,
                  class: _normalizeClass(["chef-cooking-card", { 'is-overdue': isOverdue(task) }])
                }, [
                  _createElementVNode("div", _hoisted_45, [
                    (task.imageUrl)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "chef-food-image-button",
                          "aria-label": `放大查看${task.shopFoodName || task.foodName}图片`,
                          title: "点击放大查看",
                          onClick: ($event: any) => (previewFoodImage(task))
                        }, [
                          _createElementVNode("img", {
                            src: task.imageUrl,
                            alt: task.shopFoodName || task.foodName,
                            class: "chef-food-image"
                          }, null, 8, _hoisted_47)
                        ], 8, _hoisted_46))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("strong", _hoisted_50, _toDisplayString(task.tableName || '无桌号'), 1),
                        _createElementVNode("strong", _hoisted_51, "#" + _toDisplayString(shortOrderNo(task.orderNo)), 1),
                        _createElementVNode("span", null, _toDisplayString(formatClock(task.createTime)), 1),
                        _createElementVNode("span", {
                          class: _normalizeClass({ 'chef-dine-type-highlight': dineLabel(task.dineType) !== '堂食' })
                        }, _toDisplayString(dineLabel(task.dineType)), 3),
                        (appointmentLabel(task))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(appointmentLabel(task)), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", {
                          class: _normalizeClass(["chef-priority", priorityClass(task)])
                        }, _toDisplayString(priorityLabel(task)), 3)
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("h3", null, _toDisplayString(foodDisplayName(task)), 1),
                        _createElementVNode("strong", _hoisted_54, "× " + _toDisplayString(task.quantity), 1),
                        (task.foodCookDesc?.trim())
                          ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(task.foodCookDesc), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (taskOrderRemark(task))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_56, [
                            _cache[31] || (_cache[31] = _createElementVNode("i", {
                              class: "fas fa-exclamation-circle",
                              "aria-hidden": "true"
                            }, null, -1)),
                            _createTextVNode("备注：" + _toDisplayString(taskOrderRemark(task)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (isOverdue(task))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _createElementVNode("strong", null, _toDisplayString(elapsed(task.startTime)), 1),
                        _createElementVNode("span", null, "已制作 · 标准 " + _toDisplayString(task.cookTime) + " 分钟", 1),
                        _cache[32] || (_cache[32] = _createElementVNode("span", { class: "chef-overdue-label" }, "已超时", -1))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_58, [
                    (selectedStove.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "chef-button chef-button-secondary",
                          disabled: taskActionsDisabled.value,
                          onClick: ($event: any) => (openTransfer(task))
                        }, "转交", 8, _hoisted_59))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      class: "chef-button chef-button-pause",
                      disabled: taskActionsDisabled.value,
                      onClick: ($event: any) => (changeTaskStatus(task, 9))
                    }, "暂停", 8, _hoisted_60),
                    _createElementVNode("button", {
                      type: "button",
                      class: "chef-button chef-button-complete",
                      disabled: taskActionsDisabled.value,
                      onClick: ($event: any) => (changeTaskStatus(task, 10))
                    }, _cache[33] || (_cache[33] = [
                      _createElementVNode("i", {
                        class: "fas fa-check",
                        "aria-hidden": "true"
                      }, null, -1),
                      _createTextVNode("完成", -1)
                    ]), 8, _hoisted_61)
                  ])
                ], 2))
              }), 128))
            ]))
      ]),
      _createElementVNode("section", _hoisted_62, [
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("h2", _hoisted_64, [
            _cache[34] || (_cache[34] = _createTextVNode("接下来做 ", -1)),
            _createElementVNode("span", _hoisted_65, _toDisplayString(pendingTasks.value.length), 1)
          ]),
          _cache[35] || (_cache[35] = _createElementVNode("span", { class: "chef-section-hint" }, "优先级优先 · 同级按等待时间", -1))
        ]),
        (!pendingTasks.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_66, "暂无待制作菜品"))
          : (_openBlock(), _createElementBlock("div", _hoisted_67, [
              _cache[36] || (_cache[36] = _createElementVNode("div", {
                class: "chef-queue-heading",
                "aria-hidden": "true"
              }, [
                _createElementVNode("span", null, "顺序"),
                _createElementVNode("span", null, "订单 / 时间"),
                _createElementVNode("span", null, "桌号"),
                _createElementVNode("span", null, "菜品 / 规格 / 份数"),
                _createElementVNode("span", null, "优先级 / 类型"),
                _createElementVNode("span", { class: "chef-align-right" }, "操作")
              ], -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pendingTasks.value, (task, index) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: task.orderOutId,
                  class: "chef-pending-row"
                }, [
                  _createElementVNode("strong", {
                    class: _normalizeClass(["chef-queue-rank", { 'is-next': index === 0 }])
                  }, _toDisplayString(index + 1), 3),
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("strong", _hoisted_69, "#" + _toDisplayString(shortOrderNo(task.orderNo)), 1),
                    _createElementVNode("span", null, _toDisplayString(formatClock(task.createTime)), 1)
                  ]),
                  _createElementVNode("strong", _hoisted_70, _toDisplayString(task.tableName || '无桌号'), 1),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("h3", null, _toDisplayString(foodDisplayName(task)), 1),
                      _createElementVNode("strong", _hoisted_73, "× " + _toDisplayString(task.quantity), 1),
                      (task.foodCookDesc?.trim())
                        ? (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString(task.foodCookDesc), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (taskOrderRemark(task))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_75, "备注：" + _toDisplayString(taskOrderRemark(task)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["chef-priority", priorityClass(task)])
                    }, _toDisplayString(priorityLabel(task)), 3),
                    _createElementVNode("span", {
                      class: _normalizeClass(["chef-dine-type", { 'chef-dine-type-highlight': dineLabel(task.dineType) !== '堂食' }])
                    }, _toDisplayString(dineLabel(task.dineType)), 3),
                    (appointmentLabel(task))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString(appointmentLabel(task)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    (selectedStove.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "chef-button chef-button-secondary",
                          disabled: taskActionsDisabled.value,
                          onClick: ($event: any) => (openTransfer(task))
                        }, "转交", 8, _hoisted_79))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      class: "chef-button chef-button-start",
                      disabled: taskActionsDisabled.value,
                      onClick: ($event: any) => (changeTaskStatus(task, 5))
                    }, "开始", 8, _hoisted_80)
                  ])
                ]))
              }), 128))
            ]))
      ]),
      (pausedTasks.value.length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_81, [
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("h2", _hoisted_83, [
                _cache[37] || (_cache[37] = _createTextVNode("已暂停 ", -1)),
                _createElementVNode("span", _hoisted_84, _toDisplayString(pausedTasks.value.length), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_85, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pausedTasks.value, (task) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: task.orderOutId,
                  class: "chef-paused-row"
                }, [
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("strong", _hoisted_88, _toDisplayString(task.tableName || '无桌号'), 1),
                      _createElementVNode("strong", _hoisted_89, "#" + _toDisplayString(shortOrderNo(task.orderNo)), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass({ 'chef-dine-type-highlight': dineLabel(task.dineType) !== '堂食' })
                      }, _toDisplayString(dineLabel(task.dineType)), 3),
                      (appointmentLabel(task))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_90, _toDisplayString(appointmentLabel(task)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("h3", null, _toDisplayString(foodDisplayName(task)), 1),
                      _createElementVNode("strong", _hoisted_92, "× " + _toDisplayString(task.quantity), 1),
                      (task.foodCookDesc?.trim())
                        ? (_openBlock(), _createElementBlock("span", _hoisted_93, _toDisplayString(task.foodCookDesc), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (taskOrderRemark(task))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_94, "备注：" + _toDisplayString(taskOrderRemark(task)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_95, [
                    _createElementVNode("strong", null, _toDisplayString(task.operateStatus === 1 ? '服务员暂停' : '厨师暂停'), 1),
                    _createElementVNode("span", null, _toDisplayString(task.operateStatus === 1 ? '等待服务员恢复' : '可继续制作'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_96, [
                    (selectedStove.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "chef-button chef-button-secondary",
                          disabled: taskActionsDisabled.value,
                          onClick: ($event: any) => (openTransfer(task))
                        }, "转交", 8, _hoisted_97))
                      : _createCommentVNode("", true),
                    (task.operateStatus !== 1 && task.kitchenStatus === 9)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          class: "chef-button chef-button-start",
                          disabled: taskActionsDisabled.value,
                          onClick: ($event: any) => (changeTaskStatus(task, 5))
                        }, "继续", 8, _hoisted_98))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (scheduledTasks.value.length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_99, [
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("h2", _hoisted_101, [
                _createElementVNode("button", {
                  type: "button",
                  class: "chef-scheduled-toggle",
                  "aria-expanded": scheduledExpanded.value,
                  "aria-controls": "chef-scheduled-queue",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (scheduledExpanded.value = !scheduledExpanded.value))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(scheduledExpanded.value ? 'fas fa-chevron-down' : 'fas fa-chevron-right'),
                    "aria-hidden": "true"
                  }, null, 2),
                  _cache[38] || (_cache[38] = _createTextVNode(" 预约待制作 ", -1)),
                  _createElementVNode("span", _hoisted_103, _toDisplayString(scheduledTasks.value.length), 1),
                  _createElementVNode("span", _hoisted_104, _toDisplayString(scheduledExpanded.value ? '收起' : '展开'), 1)
                ], 8, _hoisted_102)
              ]),
              _createElementVNode("span", _hoisted_105, "厨房公共预约 · 提前" + _toDisplayString(scheduleSettings.value.advanceMinutes) + "分钟进入待制作", 1)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_106, [
              _cache[39] || (_cache[39] = _createElementVNode("div", {
                class: "chef-queue-heading",
                "aria-hidden": "true"
              }, [
                _createElementVNode("span", null, "顺序"),
                _createElementVNode("span", null, "订单 / 时间"),
                _createElementVNode("span", null, "桌号"),
                _createElementVNode("span", null, "菜品 / 规格 / 份数"),
                _createElementVNode("span", null, "优先级 / 类型"),
                _createElementVNode("span", { class: "chef-align-right" }, "操作")
              ], -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scheduledTasks.value, (task, index) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: task.orderOutId,
                  class: "chef-pending-row"
                }, [
                  _createElementVNode("strong", _hoisted_107, _toDisplayString(index + 1), 1),
                  _createElementVNode("div", {
                    class: "chef-queue-order",
                    title: task.orderNo
                  }, [
                    _createElementVNode("strong", _hoisted_109, "#" + _toDisplayString(shortOrderNo(task.orderNo)), 1),
                    _createElementVNode("span", null, _toDisplayString(formatClock(task.createTime)), 1)
                  ], 8, _hoisted_108),
                  _createElementVNode("strong", _hoisted_110, _toDisplayString(task.tableName || '无桌号'), 1),
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("div", _hoisted_112, [
                      _createElementVNode("h3", null, _toDisplayString(foodDisplayName(task)), 1),
                      _createElementVNode("strong", _hoisted_113, "× " + _toDisplayString(task.quantity), 1),
                      (task.foodCookDesc?.trim())
                        ? (_openBlock(), _createElementBlock("span", _hoisted_114, _toDisplayString(task.foodCookDesc), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("p", _hoisted_115, " 预约：" + _toDisplayString(task.selfPickDate?.slice(0, 10)) + " " + _toDisplayString(task.selfPickTime), 1),
                    _createElementVNode("p", _hoisted_116, " 进入待制作：" + _toDisplayString(scheduleDateTime(_unref(kitchenReleaseTime)(task, scheduleSettings.value))) + " · " + _toDisplayString(scheduleCountdown(task)), 1),
                    (task.stoveId)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_117, "负责厨师：" + _toDisplayString(task.stoveName), 1))
                      : _createCommentVNode("", true),
                    (taskOrderRemark(task))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_118, "备注：" + _toDisplayString(taskOrderRemark(task)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_119, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["chef-priority", priorityClass(task)])
                    }, _toDisplayString(priorityLabel(task)), 3),
                    _createElementVNode("span", {
                      class: _normalizeClass(["chef-dine-type", { 'chef-dine-type-highlight': dineLabel(task.dineType) !== '堂食' }])
                    }, _toDisplayString(dineLabel(task.dineType)), 3)
                  ]),
                  _createElementVNode("div", _hoisted_120, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "chef-button chef-button-start",
                      disabled: 
                  taskActionsDisabled.value ||
                  Boolean(task.stoveId && String(task.stoveId) !== selectedStoveId.value)
                ,
                      onClick: ($event: any) => (claimScheduledTask(task))
                    }, _toDisplayString(busyTaskId.value === task.orderOutId
                    ? '处理中…'
                    : task.stoveId || !stoves.value.length
                    ? '开始制作'
                    : '认领并开始'), 9, _hoisted_121)
                  ])
                ]))
              }), 128))
            ], 512), [
              [_vShow, scheduledExpanded.value]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_van_dialog, {
      class: "chef-transfer-modal",
      width: "var(--chef-transfer-width)",
      show: transferTask.value !== null,
      title: "转交菜品",
      "show-confirm-button": false,
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_122, [
          (transferTask.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                _createElementVNode("span", _hoisted_124, _toDisplayString(transferTask.value.tableName || '无桌号'), 1),
                _createElementVNode("div", _hoisted_125, [
                  _createElementVNode("strong", null, _toDisplayString(foodDisplayName(transferTask.value)), 1),
                  _createElementVNode("strong", _hoisted_126, "× " + _toDisplayString(transferTask.value.quantity), 1)
                ]),
                (transferTask.value.foodCookDesc?.trim())
                  ? (_openBlock(), _createElementBlock("span", _hoisted_127, _toDisplayString(transferTask.value.foodCookDesc), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_128, _toDisplayString(transferTask.value?.operateStatus === 1
              ? '转交后仍保持服务员暂停。'
              : transferTask.value?.kitchenStatus === 5
              ? '将停止当前制作，由接收厨师重新开始。'
              : '转交后由接收厨师开始制作。'), 1),
          (transferTargets.value.length)
            ? (_openBlock(), _createElementBlock("label", _hoisted_129, [
                _cache[41] || (_cache[41] = _createElementVNode("span", null, "接收厨师", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((transferStoveId).value = $event)),
                  disabled: transferSubmitting.value
                }, [
                  _cache[40] || (_cache[40] = _createElementVNode("option", {
                    value: "",
                    disabled: ""
                  }, "请选择厨师", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transferTargets.value, (stove) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: stove.stoveId,
                      value: String(stove.stoveId)
                    }, _toDisplayString(stove.stoveName) + "（" + _toDisplayString(stoveTaskCount(stove.stoveId)) + " 道菜） ", 9, _hoisted_131))
                  }), 128))
                ], 8, _hoisted_130), [
                  [_vModelSelect, transferStoveId.value]
                ])
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_132, "暂无其他接单中的厨师可接收菜品，请稍后再试。")),
          _createElementVNode("div", _hoisted_133, [
            _createVNode(_component_van_button, {
              disabled: transferSubmitting.value,
              onClick: closeTransfer
            }, {
              default: _withCtx(() => _cache[42] || (_cache[42] = [
                _createTextVNode("取消", -1)
              ])),
              _: 1,
              __: [42]
            }, 8, ["disabled"]),
            _createVNode(_component_van_button, {
              type: "primary",
              loading: transferSubmitting.value,
              disabled: !transferStoveId.value,
              onClick: confirmTransfer
            }, {
              default: _withCtx(() => _cache[43] || (_cache[43] = [
                _createTextVNode("确认转交", -1)
              ])),
              _: 1,
              __: [43]
            }, 8, ["loading", "disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})